// removed by extract-text-webpack-plugin
module.exports = {"container":"SlotLabel__container___2DY2t","info-block":"SlotLabel__info-block___nY4Pk","row-container":"SlotLabel__row-container___1HQZm"};